import { Injectable } from '@angular/core';
// import { jitsuClient } from '@jitsu/sdk-js'
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root',
})
export class EventTrackerService {
//   jitsu = jitsuClient({
//     key: environment.JITSU_KEY,
//     tracking_host : environment.JITSU_URL,
// });
  constructor() {}

  // Segment Tracking methods
  easyeat_track_event(eventname, event) {
    // try {
    //   if (!this.isAdmin()) {
    //     this.jitsu.track(eventname, event);
    //   }
    // } catch (error) {}
  }

  easyeat_identify_user(eventname, event) {
    // try {
    //   if (!this.isAdmin()) {
    //     this.jitsu.id(eventname, event);
    //   }
    // } catch (error) {}
  }
  isAdmin() {
    // const admin = localStorage.getItem('is_admin');
    // if (admin && admin === '1') return true;
    // else return false;
  }
}
